export var EXPANDER_COLUMN_ID = 'expander';
export var DATE_TIME_COLUMN_ID = 'dateTime';
export var SALES_COLUMN_ID = 'sales';
export var OPEN_RATE_COLUMN_ID = 'openRate';
export var ACTIONS_COLUMN_ID = 'action';
export var CREATED_BY_COLUMN_ID = 'createdBy';
export var AUDIENCE_COLUMN_ID = 'audience';
